import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'src/app/services/shared/utility/utility.service';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';
import { ToasterService } from '../../../services/shared/toaster/toaster.service';



@Component({
  selector: 'app-utilitymenu',
  templateUrl: './utilitymenu.component.html',
  styleUrls: ['./utilitymenu.component.scss']
})
export class UtilitymenuComponent implements OnInit {

  constructor(private httpClient: HttpClient,
    private utilityService: UtilityService,
  ) { }

  userRoles: string[] = [];
  canDoFileUpload: boolean = false;
  canDoProactiveNotification: boolean = false;
  canDoBroadcast:boolean=false;
  superAdmin: boolean = false;

  ngOnInit() {
    this.userRoles = sessionStorage.getItem('userRoles') ? sessionStorage.getItem('userRoles').split(',') : [];
    let superAdminUser = this.userRoles.find(ob => ob.toLowerCase() === 'superadmin' || ob.toLowerCase() === 'super admin');
    if (superAdminUser) {
      this.superAdmin = true;
    }  
    this.canDoFileUpload = this.utilityService.ShowUtilityMenuItem(sessionStorage.getItem('userBotRoles'),"FileUpload");
    this.canDoProactiveNotification = this.utilityService.ShowUtilityMenuItem(sessionStorage.getItem('userBotRoles'),"ProactiveNotification");
    this.canDoBroadcast = this.utilityService.ShowUtilityMenuItem(sessionStorage.getItem('userBotRoles'),"Broadcast");
  }
}
